<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Prisskilte</h1>
  </div>
  <div class="comp-header__queries">
    <adm-text-search placeholder="Søg efter prisskilt" (search$)="querySearchInput($event)" [searchText]="state.filters().query ?? ''" />
    <button (click)="resetFilter()" class="comp-header__reset-button" mat-stroked-button>Nulstil</button>
    @let unallocatedPriceSigns = state.$unallocatedPriceSigns | async;
    @if (unallocatedPriceSigns && unallocatedPriceSigns.length > 0) {
      <ok-feedback-fail class="error">
        <div class="test">
          <span> Der er {{ unallocatedPriceSigns.length }} prisskilt(e) som mangler lokationstilknytning </span>
          <button mat-flat-button color="primary" type="button" (click)="openUnallocatedPriceSigns()">Tilknyt nu</button>
        </div>
      </ok-feedback-fail>
    }
  </div>
</div>

<div class="comp-main price-sign-overview">
  @let data = state.$priceSigns | async;

  @if ((appState.isInErrorState$ | async) === false) {
    <ok-card [loading]="state.loading()">
      <ok-expand-list
        [trackBy]="'price_sign_identifier'"
        [sort]="currentSort()"
        [data]="data?.items ?? []"
        [configuration]="config()"
        (sortChange)="onSortChange($event)">
      </ok-expand-list>
      <mat-paginator
        #paginator
        class="paginator"
        [pageIndex]="state.filters().page.pageIndex"
        [pageSize]="state.filters().page.pageSize"
        [length]="data?.totalCount || 0"
        [pageSizeOptions]="state.pageSizeOptions()"
        (page)="pageSwitch($event)"
        color="accent"
        [disabled]="state.loading()"></mat-paginator>
    </ok-card>

    @if (data && data.items.length === 0 && !state.loading()) {
      <div class="no-results align-center">
        <p>Der blev ikke fundet nogen tilknyttede prisskilte</p>
      </div>
    }
  }
</div>

<ng-template #vendorNoteTemplate let-priceSign>
  <span class="vendor-note ellipsis" [matTooltip]="priceSign.vendor_note" [matTooltipDisabled]="!priceSign.vendor_note">{{
    priceSign.vendor_note || ''
  }}</span>
</ng-template>

<ng-template #locationTemplate let-priceSign>
  <div class="charging-station-location-name">
    {{ priceSign.charging_station_location_name }}

    <a
      [routerLink]="['/ok-app-emulator']"
      [queryParams]="{
        chargingStationLocationIdentifier: priceSign.charging_station_location_identifier,
      }">
      <mat-icon class="google-maps-link-icon--middle-small" [matTooltip]="'Vis i app emulator'">travel_explore</mat-icon>
    </a>
  </div>
  <div class="csl-and-org">
    <div class="icon-with-text">
      <svg title="Adresse" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
      {{ priceSign.charging_station_location_address }}
    </div>
  </div>
</ng-template>

<ng-template #organizationTemplate let-priceSign>
  <a
    [routerLink]="'/organizations'"
    [queryParams]="{
      organizationId: priceSign.organization_id,
    }"
    class="icon-with-text">
    <mat-icon svgIcon="business" aria-hidden="false" title="Organisation"></mat-icon>
    {{ priceSign.organization_name }}
  </a>
</ng-template>

<ng-template #pricesHeaderTemplate>
  <div class="flex">
    Forbrugerpris
    <span
      class="info-icon margin--left-xs"
      matTooltip="Forbrugerprisen er en samlet pris for strømsats, OK-tillæg, kundetillæg og inkl. moms">
      <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
    </span>
  </div>
  <div class="tiny-text">Inkl. moms</div>
</ng-template>

<ng-template #pricesTemplate let-priceSign>
  <div class="price-sign-prices">
    @if ((priceSign.price_sign_prices?.length ?? 0) === 0) {
      <div class="price-sign-prices__no-price">
        <span>Ingen priser</span>
      </div>
    } @else {
      @for (price of priceSign.price_sign_prices ?? []; track $index) {
        <div class="price-sign-prices__price">
          <span class="icon-with-text"> {{ price.max_power }} kw:</span>
          <span>{{ price.consumer_price_per_kwh | dkCurrency }}</span>
          @if (price.price_type === 'Dynamic') {
            <svg
              class="icon-20 margin--left-xs cursor-help orange"
              [matTooltip]="'Stikket afregnes efter en dynamisk prismodel. Det betyder, at elprisen følger markedsprisen og reguleres hvert kvarter.'">
              <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
            </svg>
          }
        </div>
      }
    }
  </div>
</ng-template>
